import { Dimensions, ViewStyle } from 'react-native'
import { CarousalDimens, ListDimens, SpaceDimens } from '../../utils/utils'
import { BoxProps } from '../BoxNew'
import { TextProps } from '../TextNew/'
import { SeparatorView } from './Separator'

const deviceWidth = Dimensions.get('window').width

const styleBottomBorder = {
  borderBottomWidth: ListDimens.LIST_FOOTER_BORDER_WIDTH,
  borderBottomColor: 'GREY_SEPARATOR',
}

const DefaultWidth = {
  width: ListDimens.LIST_DEFAULT_CONTAINER_WIDTH,
}
const DefaultViewStyles = {
  listContainer: {
    flexGrow: 1,
  } as BoxProps,
  bottomContainer: {},
  viewContainerStyle: {
    ...DefaultWidth,
  } as ViewStyle,
  flatListContainerStyle: {
    alignItems: 'center',
  } as ViewStyle,
  flatListContainerStyleBorder: {} as ViewStyle,
  ListFooterContainer: {
    // flex: 1,
    width: deviceWidth,
    borderTopWidth: ListDimens.LIST_FOOTER_BORDER_WIDTH,
    borderTopColor: 'GREY_SEPARATOR',
  } as BoxProps,
  ListContainerStyleBorders: {
    borderBottomWidth: ListDimens.LIST_FOOTER_BORDER_WIDTH,
    borderBottomColor: 'GREY_SEPARATOR',
  } as BoxProps,
  ListContainerStyleTopBorders: {
    borderTopWidth: ListDimens.LIST_FOOTER_BORDER_WIDTH,
    borderTopColor: 'GREY_SEPARATOR',
  } as BoxProps,
  imageStyle: {
    width: deviceWidth,
    height: ListDimens.DEFAULT_IMAGE_HEIGHT,
  } as BoxProps,
  separatorStyle: {
    backgroundColor: 'RED',
    height: ListDimens.LIST_DEFAULT_SEPARATOR_HEIGHT,
    borderBottomWidth: ListDimens.LIST_FOOTER_BORDER_WIDTH,
    borderBottomColor: 'GREY_SEPARATOR',
  } as BoxProps,
  container: {
    flexDirection: 'column',
    alignItems: 'center',
  } as BoxProps,
  barContainer: {
    position: 'relative',
    marginVertical: ListDimens.LIST_BAR_MARGIN,
    zIndex: 2,
    flexDirection: 'row',
    overflow: 'hidden',
    justifyContent: 'center',
    flexWrap: 'wrap',
  } as BoxProps,
  carouselDots: (selected: boolean) =>
    ({
      height: ListDimens.LIST_CAROUSEL_DOTS_SIZE,
      width: ListDimens.LIST_CAROUSEL_DOTS_SIZE,
      backgroundColor: selected ? 'PRIMARY_GREY' : 'BORDER_COLOR',
      margin: ListDimens.LIST_CAROUSEL_DOTS_MARGIN,
      borderRadius: ListDimens.LIST_CAROUSEL_DOTS_BORDER_RADIUS,
    } as BoxProps),
  detailsDataContainer: {
    backgroundColor: 'BACKGROUND',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: ListDimens.LIST_DETAIL_CONTAINER_PADDING,
    marginTop: ListDimens.LIST_DETAIL_CONTAINER_MARGIN,
    width: deviceWidth,
  } as BoxProps,
  detailsDataTextLayout: {
    margin: ListDimens.LIST_DETAIL_TEXT_MARGIN,
    width: deviceWidth - 40,
  } as BoxProps,
  ListHeaderContainer: {
    default: {
      width: deviceWidth,
      height: ListDimens.LIST_HEADER_CONTAINER_HEIGHT,
      backgroundColor: 'BACKGROUND',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingHorizontal: SpaceDimens.SPACE_SMALL,
    } as BoxProps,
    location: {
      width: deviceWidth,
      height: ListDimens.LIST_HEADER_CONTAINER_HEIGHT,
      backgroundColor: 'WHITE',
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: SpaceDimens.SPACE_SMALL,
    } as BoxProps,
    blueHeader: {},
    netBanking: {
      width: '100%',
      height: ListDimens.LIST_HEADER_CONTAINER_HEIGHT,
      backgroundColor: 'BACKGROUND',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingHorizontal: SpaceDimens.SPACE_SMALL,
    } as BoxProps,
  },
  detailsDataTextTitleLayout: {
    marginLeft: ListDimens.LIST_DETAIL_CONTAINER_MARGIN,
  } as BoxProps,
  scrollIndicator: false,
  separator: null,
}

export const emptyContainer = {
  flex: 1,
  flexDirection: 'column-reverse',
  alignItems: 'center',
  justifyContent: 'center',
} as BoxProps
export const emptyText = {
  flex: 1,
  fontSize: 16,
} as BoxProps

const styles = {
  Default: {
    ...DefaultViewStyles,
    separator: SeparatorView,
    flatListContainerStyleBorder: styleBottomBorder,
  },
  OneLineOneLabel: {
    ...DefaultViewStyles,
    flatListContainerStyle: {} as ViewStyle,
    scrollIndicator: true,
  },
  OneLineLabelValue: {
    ...DefaultViewStyles,
  },
  OneLineLabelValueWithPadding: {
    ...DefaultViewStyles,
  },
  OneLineLabelError: {
    ...DefaultViewStyles,
    scrollIndicator: true,
  },
  ThreeLineFiveLabel: {
    ...DefaultViewStyles,
    scrollIndicator: true,
    flatListContainerStyleBorder: styleBottomBorder,
  },
  ListFooterAddressItem: {
    ...DefaultViewStyles,
    flatListContainerStyleBorder: styleBottomBorder,
  },
  ThreeLineFiveLabelReverse: {
    ...DefaultViewStyles,
    scrollIndicator: true,
    flatListContainerStyleBorder: styleBottomBorder,
  },
  AddressLine: {
    ...DefaultViewStyles,
    flatListContainerStyleBorder: styleBottomBorder,
  },
  Carousel: {
    ...DefaultViewStyles,
    viewContainerStyle: {
      ...DefaultViewStyles.viewContainerStyle,
      width: deviceWidth,
    } as ViewStyle,
  },
  ImageDesc: {
    ...DefaultViewStyles,
  },
  SmallImages: {
    ...DefaultViewStyles,
  },
  CarouselSmallImages: {
    ...DefaultViewStyles,
    viewContainerStyle: {
      ...DefaultViewStyles.viewContainerStyle,
      width: deviceWidth,
    } as ViewStyle,
  },
  CarouselLabel: {
    ...DefaultViewStyles,
    viewContainerStyle: {
      width: deviceWidth,
    } as ViewStyle,
  },
  FilterLabel: {
    ...DefaultViewStyles,
    flatListContainerStyle: {
      alignItems: 'flex-start',
      flexWrap: 'wrap',
      width: deviceWidth,
      marginVertical: 'MARGIN_MIN',
    } as ViewStyle,
    viewContainerStyle: {
      ...DefaultViewStyles.viewContainerStyle,
      width: deviceWidth,
    } as ViewStyle,
  },
  UserReview: {
    ...DefaultViewStyles,
    flatListContainerStyle: {
      width: deviceWidth,
      marginVertical: 8,
    } as ViewStyle,
    viewContainerStyle: {
      ...DefaultViewStyles.viewContainerStyle,
      width: deviceWidth,
    } as ViewStyle,
  },
  Upcoming: {
    ...DefaultViewStyles,
    viewContainerStyle: {
      ...DefaultViewStyles.viewContainerStyle,
      width: deviceWidth,
      marginStart: 8,
    } as ViewStyle,
  },
  Previous: {
    ...DefaultViewStyles,
    listContainer: { height: '100%' } as BoxProps,
    viewContainerStyle: {
      ...DefaultViewStyles.viewContainerStyle,
    } as ViewStyle,
  },
  CarouselFullWithDots: {
    ...DefaultViewStyles,
    viewContainerStyle: {
      ...DefaultViewStyles.viewContainerStyle,
      width: deviceWidth,
      flexGrow: 0,
    } as ViewStyle,
    barContainer: {
      zIndex: 2,
      flexDirection: 'row',
      overflow: 'hidden',
      justifyContent: 'center',
      flexWrap: 'wrap',
    } as BoxProps,
    carouselDots: (selected: boolean) =>
      ({
        height: ListDimens.LIST_CAROUSEL_DOTS_SIZE,
        width: ListDimens.LIST_CAROUSEL_DOTS_SIZE,
        backgroundColor: selected ? 'HOTEL_PRIMARY' : 'HOTEL_PRIMARY_TRANSPARENT',
        marginVertical: ListDimens.LIST_CAROUSEL_DOTS_MARGIN,
        marginHorizontal: ListDimens.LIST_CAROUSEL_DOTS_MARGIN / 2,
        borderRadius: ListDimens.LIST_CAROUSEL_DOTS_BORDER_RADIUS,
      } as BoxProps),
  },
  CarouselAge: {
    ...DefaultViewStyles,
    viewContainerStyle: {
      ...DefaultViewStyles.viewContainerStyle,
      width: CarousalDimens.CAROUSAL_AGE_CONTAINER_SIZE,
    } as ViewStyle,
  },
  CarouselRoom: {
    ...DefaultViewStyles,
    viewContainerStyle: {
      ...DefaultViewStyles.viewContainerStyle,
      width: deviceWidth,
    } as ViewStyle,
    listContainer: {
      height: CarousalDimens.CAROUSAL_ROOM_HEIGHT,
    } as BoxProps,
    barContainer: {
      flexDirection: 'row',
      overflow: 'hidden',
      justifyContent: 'center',
      width: deviceWidth,
      alignItems: 'center',
    } as BoxProps,
    bottomContainer: {
      position: 'absolute',
      bottom: CarousalDimens.CAROUSAL_ROOM_DOTS_CONTAINER_BOTTOM,
    } as BoxProps,
    carouselDots: (selected: boolean) =>
      ({
        height: ListDimens.LIST_CAROUSEL_DOTS_SIZE,
        width: ListDimens.LIST_CAROUSEL_DOTS_SIZE,
        backgroundColor: selected ? 'WHITE' : 'WHITE30',
        margin: ListDimens.LIST_CAROUSEL_DOTS_MARGIN,
        borderRadius: ListDimens.LIST_CAROUSEL_DOTS_BORDER_RADIUS,
      } as BoxProps),
  },
  CarouselRoomTypes: {
    ...DefaultViewStyles,
    viewContainerStyle: {
      width: deviceWidth,
      flexGrow: 0,
    } as ViewStyle,
    listContainer: {
      alignItems: 'center',
      justifyContent: 'space-between',
    } as BoxProps,
    barContainer: {
      flexDirection: 'row',
      overflow: 'hidden',
      justifyContent: 'center',
      paddingBottom: 8,
      width: deviceWidth,
      alignItems: 'center',
    } as BoxProps,
    bottomContainer: {} as BoxProps,
    carouselDots: (selected: boolean) =>
      ({
        height: ListDimens.LIST_CAROUSEL_DOTS_SIZE,
        width: ListDimens.LIST_CAROUSEL_DOTS_SIZE,
        backgroundColor: selected ? 'DARK_GREY' : 'GREY_1_SEPARATOR',
        marginLeft: ListDimens.LIST_CAROUSEL_DOTS_MARGIN,
        marginRight: ListDimens.LIST_CAROUSEL_DOTS_MARGIN,
        borderRadius: ListDimens.LIST_CAROUSEL_DOTS_BORDER_RADIUS,
      } as BoxProps),
  },
  CarouselFullScreen: {
    ...DefaultViewStyles,
    viewContainerStyle: {
      ...DefaultViewStyles.viewContainerStyle,
      width: deviceWidth,
      flexGrow: 0,
    } as ViewStyle,
  },
  CarousalWithDetails: {
    ...DefaultViewStyles,
    viewContainerStyle: {
      ...DefaultViewStyles.viewContainerStyle,
      width: deviceWidth,
      flexGrow: 0,
    } as ViewStyle,
    detailsDataContainer: {
      backgroundColor: 'BACKGROUND',
      flexDirection: 'row',
      alignItems: 'flex-start',
      padding: ListDimens.LIST_DETAIL_CONTAINER_PADDING,
      marginTop: ListDimens.LIST_DETAIL_CONTAINER_MARGIN,
      width: deviceWidth,
    } as BoxProps,
  },
  ThreeColumn: {
    ...DefaultViewStyles,
    flatListContainerStyleBorder: styleBottomBorder,
  },
  FourLabelThreeValue: {
    ...DefaultViewStyles,
    flatListContainerStyleBorder: styleBottomBorder,
  },
  BankListItemStyle: {
    ...DefaultViewStyles,
    flatListContainerStyleBorder: styleBottomBorder,
  },
  OneLineMediumStyle: {
    ...DefaultViewStyles,
    flatListContainerStyleBorder: styleBottomBorder,
  },
  ThreeLineImageCounter: {
    ...DefaultViewStyles,
    viewContainerStyle: {
      ...DefaultViewStyles.viewContainerStyle,
      paddingHorizontal: ListDimens.LIST_THREE_LINE_CONTAINER_MARGIN,
    } as ViewStyle,
  },

  ONELINE_STYLE: {
    ...DefaultViewStyles,
    flatListContainerStyle: {} as ViewStyle,
  },
  TwoLabelTwoValue: {
    ...DefaultViewStyles,
    flatListContainerStyle: {} as ViewStyle,
  },
  TwoLabelTwoValueWithErrorInfo: {
    ...DefaultViewStyles,
    scrollIndicator: true,
  },
  OneLineNoValue: {
    ...DefaultViewStyles,
  },
  OneLineWithArrow: {
    ...DefaultViewStyles,
    listContainer: {
      flex: 1,
      backgroundColor: 'GREY_SEPARATOR',
    } as BoxProps,
  },
  OneLineBoldTimeRightArrow: {
    ...DefaultViewStyles,
  },

  ONELINE_STYLE_WITH_IMAGE_PLACEHOLDER: {
    ...DefaultViewStyles,
    contentContainerStyle: {
      alignItems: 'center',
      height: 80,
      flexDirection: 'row',
      flexShrink: 0,
    } as BoxProps,
    titleTextStyle: {
      fontSize: 'FONT_SIZE_MEDIUM',
      fontWeight: 'FONT_WEIGHT_MEDIUM',
      color: 'BLACK',
    } as TextProps,
  },
}

const flatListContainerStyleBorder = {
  SmallImages: null,
  Carousel: null,
  ImageDesc: null,
  ThreeColumn: styleBottomBorder,
  Default: styleBottomBorder,
  OneLineOneLabel: null,
  OneLineLabelValue: null,
  OneLineLabelValueWithPadding: null,
  OneLineLabelError: null,
  ThreeLineFiveLabel: styleBottomBorder,
  ThreeLineFiveLabelReverse: styleBottomBorder,
  ListFooterAddressItem: styleBottomBorder,
  AddressLine: styleBottomBorder,
  FourLabelThreeValue: styleBottomBorder,
  BankListItemStyle: null,
  ThreeLineImageCounter: null,
  OneLineMediumStyle: styleBottomBorder,
  CarouselSmallImages: null,
  CarouselLabel: null,
  CarouselFullWithDots: null,
  CarouselAge: null,
  CarouselRoom: null,
  CarouselFullScreen: null,
  ONELINE_STYLE: null,
  TwoLabelTwoValue: null,
  TwoLabelTwoValueWithErrorInfo: null,
  OneLineWithArrow: null,
  OneLineBoldTimeRightArrow: null,
  CarouselRoomTypes: null,
  UserReview: null,
  CarouselScrollableData: null,
  OneLineNoValue: null,
  ONELINE_STYLE_WITH_IMAGE_PLACEHOLDER: null,
  Previous: null,
  Upcoming: null,
  FilterLabel: null,
}
export { styles, DefaultViewStyles, flatListContainerStyleBorder }
